import React from 'react';
import Table from '../../common/components/basic/Table';
import useBankReports from '../hooks/useBankReports';
import { css } from 'styled-components';
import { MaxWidth } from '../../common/base';
import { Anchor } from '../../common/interfaces';
import { useTranslation } from 'react-i18next';
import format from 'date-fns/format';

export default function BankReportsTable() {
  const { t } = useTranslation();
  const { error, loading, payload = [] } = useBankReports();
  const data = error ? [] : payload;
  return (
    <Table
      headers={['Document name', 'Download / View']}
      tableFlexs={[3, 1]}
      loading={loading}
      data={data.map(({ Date: date, media: { url } }) => {
        return [
          {
            render: () => (
              <div
                css={css`
                  display: flex;
                  align-items: center;
                `}
              >
                <img src="/static/images/file/ic-file-p.svg" alt="File - Icon" width={24} />
                <div
                  css={css`
                    padding-left: 48px;
                    ${MaxWidth.sm`padding-left: 15px;`}
                  `}
                >
                  {`${t('landing.reports.reports', 'Rupiah Token Attestation')} - ${format(
                    date,
                    `MMMM YYYY`
                  )}`}
                </div>
              </div>
            )
          },
          <Anchor target="_blank" rel="noreferrer noopener" href={url}>
            <b>{t('reports.item.view_file_button', 'View File')}</b>
          </Anchor>
        ];
      })}
    />
  );
}
